import { Dialog } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

import CloseSVG from '@/assets/icons/close.svg';

import { BaseModal } from './base-modal';

interface IProps {
  title: string;

  subtitle?: string;

  /** based on the state, modal will be rendered */
  isOpen: boolean;

  /** toggle modal open and close */
  toggle: () => void;

  /** JSX|String component */
  children: React.ReactNode | string;

  /** JSX|String component: ideal for action buttons */
  footer?: React.ReactNode;

  /** Hide top left corner close button is true, default: false */
  hideCloseBtn?: boolean;

  /** modal container CSS */
  conatinerClassnames?: string;
}

export const Modal: React.FC<IProps> = ({
  title,
  subtitle,
  isOpen,
  toggle,
  children,
  hideCloseBtn = false,
  conatinerClassnames,
}) => {
  const { t } = useTranslation();
  return (
    <BaseModal isOpen={isOpen}>
      <div
        className={`bg-white shadow-[0px_0px_30px_rgba(0,0,0,0.1)] rounded-xl p-8 ${conatinerClassnames}`}
      >
        {/* start: header */}
        <div className="flex justify-between w-full">
          <div className="flex items-center">
            <Dialog.Title className="text-3xl font-bold text-black-light">
              {t(title)}
            </Dialog.Title>
            {subtitle && <h2 className="text-lg text-gray-600 ml-3">{subtitle}</h2>}
          </div>
          {!hideCloseBtn && (
            <button onClick={toggle}>
              <img src={CloseSVG} alt="close" />
            </button>
          )}
        </div>
        {/* end: header */}

        {children}
      </div>
    </BaseModal>
  );
};
